export const CURRENCY_SYMBOL_MAP: { [key: string]: string } = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  CAD: '$',
  AUD: '$',
  CHF: 'Fr',
  JPY: '¥',
  CNY: '¥',
  INR: '₹',
  MXN: '$',
  BRL: 'R$',
  ZAR: 'R',
  SGD: '$',
  HKD: '$',
  NZD: '$',
  SEK: 'kr',
  NOK: 'kr',
  DKK: 'kr',
  PLN: 'zł',
  RUB: '₽',
  KRW: '₩',
  TRY: '₺',
  AED: 'د.إ',
  SAR: '﷼',
};
